// src/components/rapport/pdf/PdfExportContext.jsx
import React, { createContext, useContext, useRef } from "react";

const PdfExportCtx = createContext(null);

export function PdfExportProvider({ children }) {
  const dataRef = useRef({});
  const imgRef  = useRef({});

  const api = {
    setData: (sectionKey, payload) => {
      if (Array.isArray(payload) || payload === null || typeof payload !== "object") {
        dataRef.current[sectionKey] = payload;
        return;
      }
      dataRef.current[sectionKey] = {
        ...(dataRef.current[sectionKey] || {}),
        ...payload,
      };
    },
    getAllData: () => dataRef.current,

    setImage: (imageKey, base64) => { imgRef.current[imageKey] = base64; },
    getAllImages: () => imgRef.current,

    clear: () => { dataRef.current = {}; imgRef.current = {}; },
  };

  return <PdfExportCtx.Provider value={api}>{children}</PdfExportCtx.Provider>;
}

export function usePdfExport() {
  const ctx = useContext(PdfExportCtx);
  if (!ctx) throw new Error("usePdfExport must be used inside PdfExportProvider");
  return ctx;
}
